import { create } from 'zustand';

interface GuideState {
  isVisible: boolean;
  currentStep: number;
  setIsVisible: (visible: boolean) => void;
  setCurrentStep: (step: number) => void;
  restartGuide: () => void;
  
  showGuide: boolean;
  setShowGuide: (show: boolean) => void;
}

export const useGuideStore = create<GuideState>((set) => ({
  isVisible: false,
  currentStep: 0,
  setIsVisible: (visible) => set({ isVisible: visible }),
  setCurrentStep: (step) => set({ currentStep: step }),
  restartGuide: () => set({ isVisible: true, currentStep: 0 }),
  
  showGuide: false,
  setShowGuide: (show) => set({ showGuide: show }),
}));